import { render, staticRenderFns } from "./selectLang.vue?vue&type=template&id=42f7a31a"
import script from "./selectLang.vue?vue&type=script&lang=ts"
export * from "./selectLang.vue?vue&type=script&lang=ts"
import style1 from "./selectLang.vue?vue&type=style&index=1&id=42f7a31a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports